import { useEffect } from 'react';

export const useAutosizeTextArea = (textAreaRef, value) => {
  useEffect(() => {
    if (textAreaRef.current) {
      // Reset height to allow shrinking on deletion
      textAreaRef.current.style.height = '0px';  // Set the initial height to 25px
      // Set the height to the scroll height, but respect the max-height
      textAreaRef.current.style.height = `${Math.min(textAreaRef.current.scrollHeight, 120)}px`;
    }
  }, [textAreaRef, value]);
};
